type Props = {
  createdAt: string;
  role: string;
  readByPeer?: boolean | null;
  /** Visão portal: mostra ✓/✓✓ em OPERATOR/ASSISTANT; "Lida" em USER. */
  portal?: boolean;
};

function formatMsgTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const sameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();
  const time = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  if (sameDay) return time;
  return `${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} ${time}`;
}

export function AtendimentoMessageMeta({ createdAt, role, readByPeer, portal = true }: Props) {
  const time = formatMsgTime(createdAt);
  let receipt: string | null = null;
  if (portal) {
    if (role === 'OPERATOR' || role === 'ASSISTANT') {
      receipt = readByPeer ? '✓✓' : '✓';
    } else if (role === 'USER' && readByPeer) {
      receipt = 'Lida';
    }
  } else {
    // App cliente: lido nas próprias msgs USER; ✓ nas do operador/IA
    if (role === 'USER') {
      receipt = readByPeer ? '✓✓' : '✓';
    } else if ((role === 'OPERATOR' || role === 'ASSISTANT') && readByPeer) {
      receipt = 'Lida';
    }
  }

  return (
    <div
      className={`mt-1 flex items-center gap-1.5 text-[10px] opacity-60 ${
        role === 'USER' ? 'justify-end' : role === 'SYSTEM' ? 'justify-center' : 'justify-start'
      }`}
    >
      <span>{time}</span>
      {receipt ? (
        <span
          className={
            receipt === '✓✓' || receipt === 'Lida' ? 'text-sky-500 opacity-100' : undefined
          }
          title={
            receipt === '✓✓' || receipt === 'Lida' ? 'Lida' : receipt === '✓' ? 'Enviada' : undefined
          }
        >
          {receipt}
        </span>
      ) : null}
    </div>
  );
}
